import React from 'react';
import './SpaceBackground.css';

// Deterministic positions keep the sky stable across renders.
const stars = Array.from({ length: 180 }, (_, index) => ({
  left: `${((index * 73.31 + 11.7) % 100).toFixed(2)}%`,
  top: `${((index * index * 13.17 + index * 37.9 + 4.3) % 100).toFixed(2)}%`,
  '--star-size': `${index % 11 === 0 ? 3 : index % 3 === 0 ? 2 : 1}px`,
  '--star-duration': `${3 + (index % 7) * 0.7}s`,
  '--star-delay': `${-(index % 19) * 0.63}s`,
}));

export default function SpaceBackground() {
  return (
    <div className="space-background" aria-hidden="true">
      {stars.map((style, index) => (
        <span className="space-background__star" style={style} key={index} />
      ))}
    </div>
  );
}
